export default [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'fa-tachometer-alt',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Hashtag đơn hàng',
    group: 'apps',
    icon: 'fa-tag',
    name: 'hashtag-don-hang',
    roleId: 32
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'fa-chart-line',
    name: 'Report',
    roleId: 4,
    items: [
      {
        title: 'Công nợ',
        name: 'bao-cao-cong-no',
        component: 'bao-cao-cong-no',
        roleId: 8
      },
      {
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 8
      },
      {
        title: 'Lợi nhuận đặt hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        roleId: 1,
      },
      // { 
      //   title: 'Phí mua hàng',
      //   name: 'thong-ke-phi-mua-hang',
      //   component: 'thong-ke-phi-mua-hang',
      //   roleId: 2,
      // },
      // {
      //   title: 'Phí vận chuyển',
      //   name: 'thong-ke-phi-van-chuyen',
      //   component: 'thong-ke-phi-van-chuyen',
      //   roleId: 4
      // },
      {
        title: 'Chênh lệch tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        roleId: 8,
      },
      {
        title: 'Thống kê nạp tiền',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        roleId: 8
      },
      {
        title: 'Thống kê hoa hồng',
        name: 'thong-ke-hoa-hong-nhan-vien',
        component: 'thong-ke-hoa-hong-nhan-vien',
        roleId: 8
      },
      // {
      //   title: 'Doanh thu tổng',
      //   name: 'bao-cao-tong-hop',
      //   component: 'bao-cao-tong-hop',
      //   roleId: 8
      // },
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'apps',
    icon: 'fa-shopping-cart',
    name: 'OrderList',
    roleId: 32,
    badge: false,
    children: [
      { name: 'orderdetail', title: 'Chi tiết đơn hàng', component: 'OrderDetail' }
    ]
  },
  {
    title: 'Ký gửi',
    group: 'apps',
    icon: 'fa-cart-plus',
    name: 'Deposit',
    roleId: 32,
    badge: false,
    children: [
      { name: 'DepositDetail', title: 'Chi tiết đơn hàng', component: 'DepositDetail' }
    ]
  },
  {
    title: 'Thanh toán hộ',
    group: 'apps',
    icon: 'fa-credit-card',
    name: 'PayServiceList',
    roleId: 64,
    badge: false,
    children: [
      { name: 'PayServiceDetail', title: 'Chi tiết thanh toán hộ', component: 'PayServiceDetail' }
    ]
  },
  {
    title: 'Kế toán',
    group: 'ke-toan',
    icon: 'fa-chart-line',
    name: 'Accountant',
    roleId: 128,
    items: [
      {
        title: 'Thanh toán',
        component: 'PayOrderList',
        roleId: 2
      },
      {
        title: 'Kiểm soát đơn hàng',
        component: 'AccountantOrder',
        roleId: 16
      },
      {
        title: 'Tài chính',
        name: 'bao-cao-tai-chinh',
        component: 'bao-cao-tai-chinh',
        roleId: 16,
      },
      // {
      //   title: 'Luồng thu chi (¥)',
      //   component: 'AccountantCumulationList',
      //   roleId: 1
      // },
      // {
      //   title: 'Luồng thu chi (₫)',
      //   component: 'AccountantCumulationVNDList',
      //   roleId: 1
      // },
      {
        title: 'Shop hoàn tiền KN',
        component: 'TuiKuanList',
        roleId: 16
      },
    ]
  },  
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'fa-user',
    name: 'CustomerList',
    roleId: 8,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'RechargeNew',
    roleId: 16
  },
  {
    title: 'Rút tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'WithdrawHistory',
    roleId: 16
  },
  {
    title: 'Khiếu nại',
    group: 'apps',
    icon: 'fa-exclamation-circle',
    name: 'Complain',
    roleId: 8,
    children: [
      { name: 'ComplainDetail', title: 'Chi tiết khiếu nại', component: 'ComplainDetail' }
    ]
  },
  {
    title: 'Mã vận đơn',
    group: 'apps',
    icon: 'fa-cubes',
    name: 'Transaction',
    roleId: 512
  },
  {
    title: 'Thu chi kho TQ',
    group: 'apps',
    icon: 'fa-info-circle',
    name: 'StoreReportList',
    roleId: 8192
  }, 
  {
    title: 'Nhập kho TQ',
    group: 'apps',
    icon: 'fa-warehouse',
    name: 'StoreManager',
    roleId: 1024
  },
  {
    title: 'Bao hàng',
    group: 'apps',
    icon: 'fa-box',
    name: 'BigPackage',
    roleId: 2048
  }, 
  {
    title: 'Phiên làm việc',
    group: 'apps',
    icon: 'fa-calendar-alt',
    name: 'SessionList',
    roleId: 256
  },
  {
    title: 'Nhập kho VN',
    group: 'apps',
    icon: 'fa-store',
    name: 'StoreManagerVN',
    roleId: 256
  },
  {
    title: 'Xuất kho VN',
    group: 'xuat-kho',
    icon: 'fa-dolly-flatbed',
    name: 'VNExport',
    roleId: 4096,
    items: [
      {
        name: 'Deliverable', 
        title: 'Mã bill', 
        component: 'Deliverable',
        orderSystem: 1,
        roleId: 1
      },
      {
        name: 'ExportReceipt', 
        title: 'Phiếu xuất kho', 
        component: 'ExportReceipt',
        roleId: 1
      }
    ]
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'fa-cogs',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration',
        roleId: 1,
      },
      {
        name: 'BankInfoList', 
        title: 'TK ngân hàng', 
        component: 'BankInfoList', 
        roleId: 1,
        children: [
          { name: 'BankInfoDetail', title: 'Chi tiết ngân hàng', component: 'BankInfoDetail' }
        ]
      },
      {
        name: 'FlagList', 
        title: 'Hashtag', 
        component: 'FlagList', 
        roleId: 1,
        children: [
          { name: 'FlagDetail', title: 'Chi tiết hashtag', component: 'FlagDetail' }
        ]
      },
      {
        title: 'Kho hàng TQ',
        name: 'ChinaStoreList',
        component: 'ChinaStoreList', 
        roleId: 1,
        children: [
          { name: 'ChinaStoreDetail', title: 'Chi tiết kho TQ', component: 'ChinaStoreDetail' }
        ]
      },
      {
        title: 'Kho hàng VN',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        roleId: 1,
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho', component: 'WarehouseDetail' }
        ]
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        roleId: 2,
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        roleId: 1,
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ]
      },
      {
        name: 'PricesList', 
        title: 'Bảng giá vận chuyển', 
        component: 'PricesList', 
        roleId: 1,
        children: [
          { name: 'PricesDetail', title: 'Chi tiết bảng giá', component: 'PricesDetail' }
        ]
      },
      // {
      //   name: 'FeeWeightList', 
      //   title: 'Phí cân nặng', 
      //   component: 'FeeWeightList', 
      //   children: [
      //     { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
      //   ]
      // },
      // {
      //   name: 'FeeVolumeList', 
      //   title: 'Phí khối', 
      //   component: 'FeeVolumeList', 
      //   children: [
      //     { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
      //   ]
      // },
      {
        name: 'FeeCheckList', 
        title: 'Phí kiểm đếm', 
        component: 'FeeCheckList', 
        roleId: 1,
        children: [
          { name: 'FeeCheckDetail', title: 'Chi tiết phí kiểm đếm', component: 'FeeCheckDetail' }
        ]
      },
      {
        name: 'FeeGuaranteeList', 
        title: 'Phí bảo hiểm', 
        component: 'FeeGuaranteeList', 
        roleId: 1,
        children: [
          { name: 'FeeGuaranteeDetail', title: 'Chi tiết phí bảo hiểm', component: 'FeeGuaranteeDetail' }
        ]
      },
      {
        name: 'FeeReinforceList', 
        title: 'Phí gia cố', 
        component: 'FeeReinforceList', 
        roleId: 1,
        children: [
          { name: 'FeeReinforceDetail', title: 'Chi tiết phí gia cố', component: 'FeeReinforceDetail' }
        ]
      },
      { 
        name: 'CustomerLevel', 
        title: 'Khách hàng thân thiết', 
        component: 'CustomerLevel',
        roleId: 1,
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ]
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
